import * as yup from 'yup'
import { FormFieldSchema } from './form-field-schema'
import { StringSchemaOptions } from './types/form-field-schema-options/string-schema-options.interface'
import { FormFieldSchemaType } from './types/form-field-schema-type.enum'

export class EmailFieldSchema extends FormFieldSchema {
  protected emailRegex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
  protected schema = yup.string().matches(this.emailRegex)
  protected type: FormFieldSchemaType = FormFieldSchemaType.STRING
  private minLength: number | undefined
  private maxLength: number | undefined

  public getSchemaOptions(): StringSchemaOptions {
    return {
      name: this.name,
      type: this.type,
      minLength: this.minLength,
      maxLength: this.maxLength,
      required: this.required
    }
  }

  public setMinLength(min: number): this {
    this.minLength = min
    this.schema = this.schema.min(min).trim()
    return this
  }

  public setMaxLength(max: number): this {
    this.maxLength = max
    this.schema = this.schema.max(max).trim()
    return this
  }
}
